import Icon from "react-crypto-icons";
import { PopularCoinData } from "src/components/Referral-partner/Analytics/analyticsTypes";
import {
  PopularCoinsIconTextGroup,
  PopularCoinsLinkCoin,
  PopularCoinsList,
  PopularCoinsListItem,
  PopularCoinsText,
  PopularCoinsWrapper,
} from "src/components/Referral-partner/Analytics/styles/chart.styles";

interface PopularCoinsProps {
  data: PopularCoinData[];
}
const PopularCoins = (props: PopularCoinsProps) => {
  const { data } = props;

  const handleOnClick = (coin: PopularCoinData) => {
    console.log(`${coin.name} clicked`);
  };

  return (
    <PopularCoinsWrapper id="coin-visits-list">
      <PopularCoinsList>
        {data.map((coin, index) => (
          <PopularCoinsListItem key={index}>
            <PopularCoinsIconTextGroup onClick={() => handleOnClick(coin)}>
              <Icon name={coin.code} size={20} />
              <PopularCoinsLinkCoin to={`/coin/${coin.name}`}>{coin.name}</PopularCoinsLinkCoin>
            </PopularCoinsIconTextGroup>
            <PopularCoinsText>{coin.visits}</PopularCoinsText>
          </PopularCoinsListItem>
        ))}
      </PopularCoinsList>
    </PopularCoinsWrapper>
  );
};

export default PopularCoins;
